import * as React from "react";
import { connect } from "react-redux";
import { Model } from "@flowable/forms";
import { isNonEmptyArray } from "@cayuse/shared-react.utils.type-checks";
import Icon from "@cayuse/shared-react.components.icon";
import styles from "./styles.css";

class CopyToFrom extends Model.StatefulFormComponent {
	state = {
		touched: true,
		formValid: true,
		loading: true,
		value: null,
		copyToFromRowLookupMap: {},
		initialLoad: true
	};

	async componentDidMount () {
		if (this.state.value === null) {
			const initialValue = isNonEmptyArray(this.props.config.value)
				? this.props.config.value
				: [ {
					copyTo: null,
					copyFrom: null
				} ];

			this.setState({
				value: this.deepCopy(initialValue),
				successful: true,
				loading: false,
				copyToFromRowLookupMap: {}
			});
		}

		if (isNonEmptyArray(this.props.config.value)) {
			this.setState({ initialLoad: false });
		}
	}

	componentDidUpdate () {
	}

	shouldComponentUpdate (nextProps, nextState) {
		return nextState !== this.state;
	}

	render () {
		const { Components, onChange } = this.props;
		const { loading } = this.state;

		const disabled = this.props.config.enabled === false;
		const bem = this.bem("panel", { disabled });

		return loading ?
			(<div>Loading...</div>)
			: (
				<div className={styles.componentContainer}>
					<Components.description {...this.props}/>
					{
						this.state.value.map((copyToFromRow, index) =>
							this.renderCopyToFromRow(onChange, copyToFromRow, index, `${index}`, bem, Components))
					}
				</div>
			);
	}

	renderCopyToFromRow (onChange, copyToFromRow, index, key, bem, Components) {
		const { value } = this.state;
		const { config } = this.props;


		let setCopyToFromRowContent = (field, newValue) => {
			this.updateValue(onChange, (value => {
				value[index][field] = newValue;
			}));
		};

		let deleteEntry = () => {
			this.updateValue(onChange, value => value.splice(index, 1));
		};

		let addEntry = () => {
			this.updateValue(onChange, value => value.push({
				copyTo: null,
				copyFrom: null
			}));
		};


		//building configs for both dropdowns
		let copyTo = this.getSelectConfig("Copy To", config.$path, index, "copyTo", copyToFromRow);
		let copyFrom = this.getSelectConfig("Copy From", config.$path, index, "copyFrom", copyToFromRow);

		//determining last element
		let isLastElement = index === value.length - 1;

		// hide errors for last element if both dropdowns are not filled out
		if (isLastElement && !CopyToFrom.isPresent(copyToFromRow)) {
			copyFrom.$errors = [];
			copyTo.$errors = [];
		}

		//todo not yet implemented
		return (""
		);
	}

	updateValue (onChange, setValue) {
		const { value } = this.state;
		setValue(value);
		onChange(this.cleanupForPayload(value));
		this.setState({
			value: this.deepCopy(value),
			copyToFromRowLookupMap: {},
			initialLoad: false
		});
	}

	cleanupForPayload (content) {
		return content;
	}

	getSelectConfig (label, path, index, field, item, items) {
		let value = item[field];

		//dummy dropdown items
		let dummyDropdownItems = [ "1", "2", "3", "4", "5", "6", "7", "8", "9", "10" ];

		return {
			label: label,
			$path: `${path}.${index}.${field}`,
			type: "select",
			$errors: CopyToFrom.validateIsRequired(value),
			value: value,
			enabled: true,
			extraSettings: this.extraSettings(dummyDropdownItems)
		};
	}

	static validateIsRequired (value) {
		let errors = [];
		if (!this.isPresent(value)) {
			errors.push("isRequired");
		}

		return errors;
	}

	extraSettings (items) {
		return {
			enableAutocomplete: true,
			dataSource: "Static",
			items: items,
			storage: "Id",
			identity: "id",
			multi: false
		};
	};

	static isPresent (value) {
		return value !== undefined && value !== null && value !== "";
	}

	deepCopy (value) {
		return JSON.parse(JSON.stringify(value));
	}
}

const mapStateToProps = state => ({
	//to be changed
	//roles: state.picklists.researchTeamRoles?.options || []
});

export default connect(mapStateToProps)(CopyToFrom);

